// İSG Portal — PageHeader (S33 planı Stage 2/4, yeni): Breadcrumb'ın altında, sayfanın
// zorunlu başlık bloğu (plan §"Mandatory page anatomy" — Breadcrumb → PageHeader → İçerik).
// Henüz hiçbir sayfa tüketmiyor (ilk gerçek tüketici Slice 3 permit detayı + Slice 4 liste
// sayfaları). `id`/`tags`/`helperText` satırı yalnız EN AZ biri verildiğinde render edilir.

import type { ReactNode } from 'react';
import { cn } from './cn';

export function PageHeader({
  title,
  id,
  tags,
  helperText,
  actions,
  className,
}: {
  title: ReactNode;
  /** Başlığın altındaki tanımlayıcı (ör. permit kodu) — `text-muted`. */
  id?: ReactNode;
  /** `Tag` bileşenlerinden oluşan liste. */
  tags?: ReactNode;
  /**
   * Sayfa anatomisinin tek-satır ALT BAŞLIĞI (S33-8 review fix #4 — bu bileşenin `subtitle`u):
   * başlığın hemen altında, 12px/`text-muted`. "Breadcrumb → büyük başlık → tek satır alt
   * başlık → sağda birincil aksiyon" zorunlu anatomisinin üçüncü parçası — ayrı bir `subtitle`
   * prop'u AÇILMADI, bu ZATEN o roldeydi (bkz. `DocumentTypesListPage.tsx`/
   * `PermitsListPage.tsx`'in mevcut kullanımı); yalnız isim/niyet burada netleştirildi.
   */
  helperText?: ReactNode;
  /** Sağdaki `ButtonSet` — alta hizalı. */
  actions?: ReactNode;
  className?: string;
}) {
  const hasMetaRow = id != null || tags != null || helperText != null;
  // `mb-6` KASITLI YOK (S33 fix, coordinator bulgusu) — bu bileşen HER ZAMAN bir `flex
  // flex-col gap-*` sütununun doğrudan çocuğu olarak kullanılır (bkz. tek gerçek tüketici
  // `PermitDetailPage.tsx`); kendi `margin-bottom`'u ile ebeveynin flex `gap`'i TOPLANIR
  // (margin flex gap ile ÇÖKMEZ), 24px yerine 48px verirdi. Aralığı ebeveynin `gap`'i taşır.
  return (
    <div className={cn('flex items-end justify-between gap-4', className)}>
      <div className="min-w-0 flex-1">
        <h1 className="truncate text-2xl font-semibold text-fg carbon:text-[28px] carbon:font-normal carbon:leading-9">
          {title}
        </h1>
        {hasMetaRow ? (
          <div className="mt-1 flex flex-wrap items-center gap-2 carbon:mt-2">
            {id != null ? (
              <span className="tnum text-sm text-muted carbon:text-xs">{id}</span>
            ) : null}
            {tags}
            {helperText != null ? (
              <span className="text-sm text-muted carbon:text-xs carbon:tracking-[.32px]">
                {helperText}
              </span>
            ) : null}
          </div>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </div>
  );
}
